import {
  Button, Dialog, DiffViewer, Modal,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { IQueryTemplateAuditEntry } from 'common/interfaces/query';
import { useTranslation } from 'react-i18next';
import { QUERY_AUDIT_ACTION_LABEL_MAP } from './query-changes-utils';

interface IQueryChangeDetailsModalProps {
  entry: IQueryTemplateAuditEntry;
  onClose: () => void;
}

export const QueryChangeDetailsModal = ({ entry, onClose }: IQueryChangeDetailsModalProps) => {
  const { t } = useTranslation();
  const { before, after, queryName } = entry.information;

  return (
    <Modal visible centered onEscape={onClose}>
      <Dialog
        dialog={{
          scroll: true,
          heading: `${t(QUERY_AUDIT_ACTION_LABEL_MAP[entry.action])}: ${queryName}`,
          content: (
            <DiffViewer
              oldJson={JSON.stringify(before ?? {}, null, 2)}
              newJson={JSON.stringify(after ?? {}, null, 2)}
            />
          ),
          footer: <Button label={t(translations.cancel)} onClick={onClose} />,
          onClose,
          width: '90%',
        }}
      />
    </Modal>
  );
};
